<template>
	<div v-if="statusEntries.length">
		<div class="order-progression">
			<div class="inner-container">
				<div v-for="(entry, index) in (isExpanded ? statusEntries : statusEntries.slice(0, 1))" class="order-status-event" :key="entry.id + '-' + index">
					<div class="icon">
						<span :style="{ backgroundImage: 'url(\'' + getEntryIconUrl(entry) + '\')' }" />
					</div>
					<h3 class="level-two-heading">{{ entry.title }}</h3>
					<span v-if="entry.date" class="secondary">
						{{ entry.date }}
					</span>
					<div class="secondary">
						<span v-if="entry.message" v-html="entry.message" ref="message"></span>
						<ul>
							<li v-for="subEntry in entry.subEntries" ref="message" v-html="subEntry.message" :key="subEntry.id" />
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div v-if="statusEntries.length > 1 && ! isExpanded" class="status-entries">
			<a @click="isExpanded = true">Visa historik</a>
		</div>
	</div>
</template>

<script>
import { fixRelativeLinks } from 'utils';
import PHPDate from 'PHPDate';

// Order tracking event statuses.
const EVENT_STATUS = {
	RECEIVED: 1,
	PACKED: 2,
	SHIPPED: 3,
	PICKUP_READY: 4,
	CANCELED: 5,
	AWAITING_SUPPLIER_ORDER: 6,
	AWAITING_INTERNAL_DELIVERY: 7,
	AWAITING_PRODUCT_RELEASE: 8,
};

export default {
	props: {
		order: {
			type: Object,
			default: () => null,
		},
		statusEntries: {
			type: Array,
			default: () => [],
		},
	},
	data () {
		return {
			EVENT_STATUS,
			isExpanded: false,
		};
	},
	methods: {
		formatTimestamp (timestamp) {
			return PHPDate('Y-m-d H:i', timestamp);
		},
		getEntryIconUrl (entry) {
			if (! entry.status.icon) {
				return '/api/dynimg/info/webhallen_w/ffffff';
			}
			return '/api/dynimg/icon/' + entry.status.icon + '/ffffff';
		},
	},
	mounted () {
		if (this.statusEntries.length) {
			Vue.nextTick(() => {
				for (const ref of this.$refs.message) {
					// Fix links in messages.
					fixRelativeLinks(ref);
				}
			});
		}
	},
	watch: {
		statusEntries () {
			Vue.nextTick(() => {
				if (this.$refs.message) {
					for (const ref of this.$refs.message) {
						fixRelativeLinks(ref);
					}
				}
			});
		},
	},
};
</script>